import { render } from "./TradePopover.vue?vue&type=template&id=41487bb6&ts=true"
import script from "./TradePopover.vue?vue&type=script&lang=ts"
export * from "./TradePopover.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\projects\\wintick\\wintick-applets-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__